export default __webpack_public_path__ + "static/media/avalanche.0a9ba598.svg";